import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

let kejianrouter = new Router({
    routes: [{
            path: '/',
            name: 'Home',
            meta:{
            keepAlive:false
            },
            component: () =>
              /*   import ('./views/Home.vue'), */
              import('./views/aiRecommendation.vue'),

        },
        {
            path: '/Home',
            name: 'Home',
            component: () =>
                import ('./views/Home.vue'),
        },
        {
            path: '/aboutus',
            name: 'aboutus',
            component: () =>
                import ('./views/aboutus.vue'),
        },
        {
            path: '/news',
            name: 'news',
            component: () =>
                import ('./views/News.vue'),
        },
        {
            path: '/consultant',
            name: 'consultant',
            meta:{
                keepAlive:false
                },
            component: () =>
                import ('./views/Consultant.vue'),
        },
        {
            path: '/consultDetails',
            name: 'ConsultDetails',
            meta:{
                keepAlive:false
                },
            component: () =>
                import ('./views/ConsultDetails.vue'),
        },
        {
            path: '/agreement',
            name: 'Agreement',
            component: () =>
                import ('./views/Agreement.vue'),
        },
        {
            path: '/founder',
            name: 'founder',
            component: () =>
                import ('./views/founder.vue'),
        },
        {
            path: '/onebyone',
            name: 'onebyone',
            component: () =>
                import ('./views/onebyone.vue'),
        },
        {
            path: '/talent',
            name: 'talent',
            component: () =>
                import ('./views/talent.vue'),
        },
        {
            path: '/officialvisit',
            name: 'officialvisit',
            component: () =>
                import ('./views/officialvisit.vue'),
        },
        {
            path: '/summerschool',
            name: 'summerschool',
            component: () =>
                import ('./views/summerschool.vue'),
        },
        {
            path: '/jobfairs',
            name: 'jobfairs',
            component: () =>
                import ('./views/jobfairs.vue'),
        },
        {
            path: '/contactus',
            name: 'contactus',
            component: () =>
                import ('./views/contactus.vue'),
        },
        {
            path: '/privacypolicyzh',
            name: 'privacypolicyzh',
            component: () =>
                import ('./views/privacypolicyzh.vue'),
        },
        {
            path: '/privacypolicyen',
            name: 'privacypolicyen',
            component: () =>
                import ('./views/privacypolicyen.vue'),
        },
        {
            path: '/aboutus',
            name: 'aboutus',
            component: () =>
                import ('./views/aboutus.vue'),
        },
        {
            path: '/newsdetails/:id',
            name: 'newsdetails',
            component: () =>
                import ('./views/NewsDetails.vue'),
        },
        {
            path: '/case',
            name: 'case',
            component: () =>
                import ('./views/Case.vue')
        },
        {
            path: '/casedetails/:id',
            name: 'casedetails',
            component: () =>
                import ('./views/CaseDetails.vue')
        },
        {
            path: '/goin',
            name: 'goin',
            component: () =>
                import ('./views/GoIn.vue')
        },
        {
            path: '/download',
            name: 'download',
            component: () =>
                import ('./views/Download.vue')
        },
        {
            path: '/login',
            name: 'login',
            component: () =>
                import ('./views/Login.vue')
        },
        {
            path: '/admin',
            name: 'admin',
            meta: {
                requireAuth: true
            },
            component: () =>
                import ('./views/Admin.vue'),
            children: [{
                    path: '/admin/user',
                    name: 'user',
                    component: () =>
                        import ('./views/Admin/User.vue')
                },
                {
                    path: '/admin/news',
                    name: 'new',
                    component: () =>
                        import ('./views/Admin/News.vue')
                },
                {
                    path: '/admin/cases',
                    name: 'cases',
                    component: () =>
                        import ('./views/Admin/Cases.vue')
                },
                {
                    path: '/admin/team',
                    name: 'team',
                    component: () =>
                        import ('./views/Admin/Team.vue')
                },
                {
                    path: '/admin/course',
                    name: 'course',
                    component: () =>
                        import ('./views/Admin/Course.vue')
                },
                {
                    path: '/admin/enterprise',
                    name: 'enterprise',
                    component: () =>
                        import ('./views/Admin/Enterprise.vue')
                },
                {
                    path: '/admin/honor',
                    name: 'honor',
                    component: () =>
                        import ('./views/Admin/Honor.vue')
                },
                {
                    path: '/admin/dictionary',
                    name: 'dictionary',
                    component: () =>
                        import ('./views/Admin/Dictionary.vue')
                },
                {
                    path: '/admin/page',
                    name: 'page',
                    component: () =>
                        import ('./views/Admin/Page.vue')
                }
            ]
        },
        {
            path: '/productList',
            name: 'productList',
            component: () =>
                import ('./views/ProductList.vue'),
            meta: { customData: '1' }
        },
        {
            path: '/JobList',
            name: 'JobList',
            component: () =>
                import ('./views/JobList.vue'),
            meta: { customData: '1' }
        },
        {
            path: '/aiRecommendation',
            name: 'aiRecommendation',
            component: () =>
                import ('./views/aiRecommendation.vue'),
            meta: { customData: '1' }
        },
        {
            path: '/JobListwap',
            name: 'JobListwap',
            component: () =>
                import ('./views/JobListwap.vue'),
            meta: { customData: '1' }
        },
        {
            path: '/jobApply',
            name: 'jobApply',
            component: () =>
                import ('./views/jobApply.vue'),
            meta: { customData: '1' }
        },
        {
            path: '/success',
            name: 'jobApply',
            component: () =>
                import ('./views/success.vue'),
            meta: { customData: '1' }
        },
        {
            path: '/Consulttantsuccess',
            name: 'jobApply',
            component: () =>
                import ('./views/Consulttantsuccess.vue'),
            meta: { customData: '1' }
        },
        {
            path: '/ConsultantList',
            name: 'ConsultantList',
            component: () =>
                import ('./views/ConsultantList.vue'),
            meta: { customData: '1' }
        },
        {
            path: '/advertisement',
            name: 'advertisement',
            component: () =>
                import ('./views/advertisement.vue'),
            meta: { customData: '1' }
        },
        {
            path: '/activity',
            name: 'activity',
            component: () =>
                import ('./views/activity.vue'),
            meta: { customData: '1' }
        },
        {
            path: '/consultingService',
            name: 'consultingService',
            component: () =>
                import ('./views/consultingService.vue'),
            meta: { customData: '1' }
        },
    ]
})

// 判断是否需要登录权限 以及是否登录
kejianrouter.beforeEach((to, from, next) => {
    // 判断是否需要登录权限
    if (to.matched.some(res => res.meta.requireAuth)) {
        // 判断是否登录
        if (sessionStorage.getItem('token')) {
            next()
        } else {
            // 没登录则跳转到登录界面
            next({
                path: '/login',
                query: {
                    redirect: to.fullPath
                }
            })
        }
    } else {
        next()
    }
})

export default kejianrouter